/**
 * @example ng-ticker="3000" for a 3 seconds switch
 * @returns {{link: link}}
 * @todo = this should be changed to a service
 */

export default function ngTicker() {
    return {
        /**
         * @param $params.ngTicker
         */
        link: function ($scope, $item, $params ) {
            $scope.$watch('service', function ($service) {
                if ( $service.hasOwnProperty('ticker')) {
                    let $active = 0;
                    setInterval(function () {
                        if ( $active + 1 === $scope.service.ticker.length) {
                            $active = 0;
                        } else {
                            $active ++;
                        }

                        for ( let i in $scope.service.ticker) {
                            if ( $scope.service.ticker.hasOwnProperty(i)) {
                                $scope.service.ticker[i].active = (parseInt(i) === parseInt($active));
                            }
                        }
                        $scope.$apply();
                    }, $params.ngTicker );
                }
            });

        }
    }
}